import React from "react";
import PulseLoader from "react-spinners/PulseLoader";

export const ServiceLocation = ({
  getLocationHandler,
  handleShowmap,
  submitLoading,
  submitRequest,
  whereAbout,
}) => {
  return (
    <div className="serviceLocWrapper">
      <h4>محلی که متخصص ما باید برای ارائه خدمت مراجعه کند را ثبت کنید</h4>
      <div className="searchBar">
        <div className="search">
          <textarea
            value={whereAbout}
            placeholder=" محل تقریبی"
            onChange={(e) => {
              getLocationHandler(e.target.value);
            }}
          />
        </div>
      </div>

      <div
        className="DetailMap"
        onClick={() => {
          handleShowmap(true);
        }}
      >
        <img src="/public/assets/map.jpg" className="Mapbody" alt="map" />
        <img
          src="/public/assets/icons/locationInMap.svg"
          className="LocationMap"
          alt="location"
        />
        <span>موقعیت آدرس را روی نقشه مشخص کنید</span>
      </div>

      {submitLoading ? (
        <div className="serviceContinueBtn">
          <PulseLoader />
        </div>
      ) : (
        <div className="serviceContinueBtn">
          <span onClick={submitRequest}>ادامه </span>
        </div>
      )}
    </div>
  );
};
